export const loadDomainsValidation = {
  loadDomainsValidationSuccess: state => {
    state.loadDomainsValidationMessage = [];
  },
  loadDomainsValidationError: (state, {payload}) => {
    state.loadDomainsValidationMessage = payload.message
  },
}
